import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import {CircularProgress, makeStyles} from "@material-ui/core";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
    root: {
        border: "1px solid #efeff5",
        borderRadius: "8px",
    },
    cardHeader: {
        backgroundColor: "#fff",
    },
}));

const WhiteHeaderCard = (props) => {
    const classes = useStyles();

    return (
        <Card elevation={props.elevationValue} className={`${classes.root}`}>
            <CardHeader
                disableTypography={false}
                titleTypographyProps={{variant: "h6"}}
                className={classes.cardHeader}
                title={props.title}/>
            <CardContent>
                {props.loading ? <div className="text-center">
                    <CircularProgress size={64}/>
                </div> : props.children}
            </CardContent>
        </Card>
    );
};
WhiteHeaderCard.propTypes = {
    title: PropTypes.string,
    loading: PropTypes.bool
};

WhiteHeaderCard.defaultProps = {
    elevationValue: 0,
    loading: false
}

export default WhiteHeaderCard;
